import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class BringozPackagesItemsDisplayListComponent implements IController {
  items: any;
  isDisplayIds: boolean;

  public itemsDisplay: string[];
  private sitePackageItemsMap: any;


  constructor(private splitService) {
  }

  $onInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    if (this.items) {
      this.initItemsData();
    }
  }

  $onChanges(changes) {
    if (changes.items && !changes.items.isFirstChange()) {
      if (this.items) {
        this.initItemsData();
      }
    }
  };

  private initItemsData() {
    if(this.isDisplayIds){
      this.itemsDisplay = _.chain(this.items)
        .filter(i => i.id)
        .map(i => {
          return i.id
        })
        .value()
    } else {
      this.itemsDisplay = _.map(this.items, item => {
        if(item.size){
          return this.sitePackageItemsMap[item.size].name;
        } else {
          return this.sitePackageItemsMap[item.type].name;
        }
      })
    }

  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozPackagesItemsDisplayList', {
    bindings: {
      items: '<',
      isDisplayIds: '<'
    },
    template: require('./bringoz-packages-items-display-list.html').default,
    controller: BringozPackagesItemsDisplayListComponent
  });


